module.exports = __webpack_public_path__ + "static/onepager-536e74577d41f8ab631eacf0bc297616.jpg";